import { useAuthStore } from "@/stores/useAuthStore";

/**
 * Thin selector over useAuthStore.impersonation.
 * Kept separate from useAuthStore to narrow the re-render surface of
 * ImpersonationBanner (banner only re-renders when impersonation changes,
 * not on every auth state update).
 */
export function useImpersonationStore() {
  return useAuthStore((state) => state.impersonation);
}
